import React from 'react'
import { Box, Typography } from '@mui/material'
import { Alert, AlertTitle } from '@mui/material'

import { BasicListItem } from '../../../../ui'
import { useIPDetail } from '../../contexts'

export const IPNonconfomityView = () => {
  const { ip } = useIPDetail()
  const addresses = ip.direcciones

  return (
    <Box>
      <Box mt={1} mb={4}>
        <Alert severity="info">
          <AlertTitle>Observaciones:</AlertTitle>
          {ip.observaciones || 'Sin observaciones'}
        </Alert>
      </Box>
      <Typography variant="h6" color="primary" paragraph>
        Direcciones:
      </Typography>
      {addresses.map((address, i) => (
        <React.Fragment key={i}>
          <Typography variant="subtitle1" gutterBottom>
            {address.cod_derivacion}
          </Typography>
          <Typography variant="body1" color="textSecondary" paragraph>
            {`${address['via'] || ''} ${address['numero'] || ''}, ${address['poblacion'] || ''} (${
              address['codigopostal'] || ''
            }), ${address['provincia'] || ''}` +
              '\n' +
              `${address['bloque'] ? ', Portal: ' + address['bloque'] : ''}` +
              `${address['escalera'] ? ', Escalera: ' + address['escalera'] : ''}`}
          </Typography>
          <BasicListItem
            {...{ label: 'Nº CUPS', value: address['count_cups'] || 'No hay información' }}
          />
          <BasicListItem {...{ label: 'Tipo de gas', value: address['tipo_gas'] }} />
        </React.Fragment>
      ))}
    </Box>
  )
}
